import axios from 'axios'
import {ALTERAR_TIPO_PRECO_ITINERARIOS_EM_LOTE} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export function alterarTipoPrecoItinerarioEmLote(parametros) {
    const url = `${URL}/itinerario/alterar-tipo-preco-itinerarios-em-lote`;
    return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: ALTERAR_TIPO_PRECO_ITINERARIOS_EM_LOTE,
            payload: response
        })
    );
}
